"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Img = void 0;
var _react = require("react");
var _Img = _interopRequireDefault(require("./Img.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Img = props => {
  const {
    onLoad,
    onError,
    src,
    fallback,
    alt = ''
  } = props;
  const [imageSrc, setImageSrc] = (0, _react.useState)(src ?? fallback);
  const styles = (0, _Img.default)(props);
  const handleLoad = () => {
    if (onLoad) {
      onLoad();
    }
  };
  const handleError = () => {
    if (fallback) {
      setImageSrc(fallback);
    }
    if (onError) {
      onError();
    }
  };
  (0, _react.useEffect)(() => {
    setImageSrc(src ?? fallback);
  }, [fallback, src]);
  if (!src && !fallback) {
    throw new Error('Img must have either url or fallback');
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    className: styles['cc-Img'],
    onLoad: handleLoad,
    onError: handleError,
    src: imageSrc,
    alt: alt
  });
};
exports.Img = Img;